import React from 'react';
import './RecommendedVideos.css';
import VideoCard from './VideoCard'

function RecommendedVideos() {
    return (
        <div className="recommendedVideos">
            <h2>Recommended</h2>
            <div className="recommendedVideos__videos">
                <VideoCard 
                    title="🔴 Let's Build a YouTube Clone with REACT JS for Beginners"
                    views="176K views"
                    timestamp="10 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLRbdv3Di8paQyrgMF_VwFXPkhwVzcW59Vgo8dTsyw=s176-c-k-c0x00ffffff-no-rj"
                    channel="Clever Programmer"
                    image="https://i.ytimg.com/vi/NT299zIk2JY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBqZPjIgBJ_NTf7TnAGCXmQQ5C85Q"
                />
                
                <VideoCard 
                    verified
                    title="LOKI: EXILES of the MCU! Earth Next For DESTRUCTION?! | BQ"
                    views="56K views"
                    timestamp="3 hours ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLRyXeeQWaPTXSBH2RqahDs80o_ZXAEz53zeSoqfsA=s68-c-k-c0x00ffffff-no-rj"
                    channel="New Rockstars"
                    image="https://i.ytimg.com/vi/h2tez97dvHs/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA2GB4GPG_o3siiNq8j4DCu6YOJ9w"
                />

                <VideoCard 
                    verified
                    title="ZenFone 8 + Flip - SO GOOD!"
                    views="756K views"
                    timestamp="1 month ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLQjae6b5utMZa4thBe_Lj3b80UwxpctudgPiiVCGQ=s68-c-k-c0x00ffffff-no-rj"
                    channel="Dave 2D"
                    image="https://i.ytimg.com/vi/651JOj-E1qo/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBWVVww-xjFn7t7JjzwXflhkcL4pw"
                />
                <VideoCard 
                    verified
                    title="People MUST be buying these?! - ORIGIN PC EON-17X Showcase"
                    views="116K views"
                    timestamp="50 minutes ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLSGE5pCFbd5alFmWeOJZPNjsEhkN1FCxFdYjaE3Og=s68-c-k-c0x00ffffff-no-rj"
                    channel="Linus Tech Tips"
                    image="https://i.ytimg.com/vi/9E2kZqsXp4A/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAeLOj5uLZb1_pWR1jvLSTHofWFLA"
                />
                <VideoCard 
                    verified
                    title="LG's New HUGE Gaming OLED Display..."
                    views="320K views"
                    timestamp="2 hours ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLQyBKBEyT9H2wewYdj5iehfaZQIf-kfeNnW8-yp_w=s68-c-k-c0x00ffffff-no-rj"
                    channel="Unbox Therapy"
                    image="https://i.ytimg.com/vi/PZg7G9c6xwM/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDLKytcXRpUUmITXVAc6JP_dFxWSg"
                />
                <VideoCard 
                    verified
                    title="THE TGI FRIDAY'S FULL TAKE-OUT MENU CHALLENGE | BeardMeatsFood"
                    views="396K views"
                    timestamp="2 days ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLQKio6anzupNEXvDd-_Ac8gymfgTw4KALkX6oTsww=s68-c-k-c0x00ffffff-no-rj"
                    channel="BeardMeatsFood"
                    image="https://i.ytimg.com/vi/joXOQxMl4vI/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBXKmoVv2EPxK3c7Uv4wMVWi-mILg"
                />
                <VideoCard 
                    verified
                    title="Our Texas Loft Condo Tour !! Before Renovation in DFW"
                    views="76K views"
                    timestamp="3 weeks ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLTyR1Cnn7eVt0xSVecTE7I3hipLLT_P9xdLC2ND_To=s68-c-k-c0x00ffffff-no-rj"
                    channel="Sara Dietschy"
                    image="https://i.ytimg.com/vi/akbv9Fo6A7Q/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCEItRIxbfbwgqFzlod8Fj8x8qN-w"
                />
                <VideoCard 
                    verified
                    title="Why Everything is an Ultrabook!"
                    views="1.3M views"
                    timestamp="6 days ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLR-pT_JEsz_hcaA4Gjx8DHcqJ8mS42aTRqcVy6P7w=s68-c-k-c0x00ffffff-no-rj"
                    channel="Marques Brownlee"
                    image="https://i.ytimg.com/vi/U3JprndeVYU/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDd4UDjgp75uIPy-5fLVclmN83F2Q"
                />
                <VideoCard 
                    verified
                    title="This ANCIENT Lens will shock you! #Shorts"
                    views="159K views"
                    timestamp="5 days ago"
                    channelImage="https://yt3.ggpht.com/ytc/AKedOLS0I-R-Dvuc19kvQggomBGyXIbAqE11nJdude7L6Q=s68-c-k-c0x00ffffff-no-rj"
                    channel="Peter McKinnon"
                    image="https://i.ytimg.com/vi/9QAFu386WCU/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCAv2Hy-n3BVfNwEHOxaukdZ2_mHA"
                />
                
                
            </div>
        </div>
    )
}

export default RecommendedVideos;
